import api from '../api'

// COMPANY ROLES
export const postRole = (params) => api.post('/companies/roles', params)

export const putRole = (params) => api.put(`/companies/roles/${ params.id }`, params)

export const deleteRole = (params) => api.delete(`/companies/roles/${ params.id }`)

// FARM ROLES
export const postFarmRole = (params) => api.post('/companies/farms/roles', params)

export const putFarmRole = (params) => api.put(`/companies/farms/roles/${ params.id }`, params)

export const deleteFarmRole = (params) => api.delete(`/companies/farms/roles/${ params.id }`)

export const toggleFarmRoleModules = (params) => api.put(`/companies/farms/roles/modules/${ params.id }`, params)
